export default __webpack_public_path__ + "static/media/advisor-kha-nguyen.f1728d28.jpg";